/* =========================================================
   RasoiShop – Diwali Festive Theme (Dawn)
   Reads window.DiwaliFestive (set in snippets/diwali-festive.liquid)
   ========================================================= */
(function () {
  'use strict';

  var C = window.DiwaliFestive;
  if (!C || !C.enabled) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Never decorate inside the cart drawer or search dropdown
  // Blog / article cards also use .card__media in Dawn – keep them without a garland
  var EXCLUDE = 'cart-drawer, .cart-drawer, predictive-search, .predictive-search, .dw-bar, ' +
    '.article-card, .blog, .blog-posts, .main-blog, .blog-placeholder, [class*="blog"], [id*="blog"]' +
    (C.excludeSelector ? ', ' + C.excludeSelector : '');

  /* ---------- Toran injection ---------- */
  function makeToran(kind) {
    var el = document.createElement('div');
    el.className = 'dw-toran dw-toran--' + kind;
    el.setAttribute('aria-hidden', 'true');
    return el;
  }

  function hasToran(host) {
    for (var i = 0; i < host.children.length; i++) {
      if (host.children[i].classList.contains('dw-toran')) return true;
    }
    return false;
  }

  function decorate(selector, kind) {
    if (!selector) return;
    var nodes;
    try {
      nodes = document.querySelectorAll(selector);
    } catch (e) {
      console.warn('[Diwali] Invalid selector in Theme settings:', selector);
      return;
    }
    for (var i = 0; i < nodes.length; i++) {
      var host = nodes[i];
      var excluded = false;
      try { excluded = !!host.closest(EXCLUDE); } catch (e) { excluded = !!host.closest('.article-card, [class*="blog"]'); }
      if (hasToran(host) || excluded) continue;
      // Skip if a parent box already carries a garland (prevents double toran)
      if (kind !== 'header' && host.parentElement &&
          host.parentElement.closest('[data-dw="card"], [data-dw="product"]')) continue;
      host.setAttribute('data-dw', kind);
      if (window.getComputedStyle(host).position === 'static') {
        host.style.position = 'relative';
      }
      host.appendChild(makeToran(kind));
    }
  }

  /* ---------- Search fix: hide header toran while search is open ---------- */
  var SEARCH_OPEN = 'predictive-search[open], predictive-search[results], .predictive-search[open], ' +
    '.search-modal[open], details[open] > .search-modal, ' +
    'input[type="search"][aria-expanded="true"], input[name="q"][aria-expanded="true"]';

  function isSearchField(el) {
    return !!el && el.tagName === 'INPUT' &&
      (el.type === 'search' || el.name === 'q' || !!el.closest('predictive-search, .predictive-search, .search, form[action*="/search"]'));
  }

  function syncSearch() {
    var open = isSearchField(document.activeElement);
    if (!open) { try { open = !!document.querySelector(SEARCH_OPEN); } catch (e) {} }
    document.documentElement.classList.toggle('dw-search-open', open);
  }

  function watchSearch() {
    var later = function () { setTimeout(syncSearch, 150); };
    document.addEventListener('focusin', syncSearch, true);
    document.addEventListener('focusout', later, true);
    document.addEventListener('input', syncSearch, true);
    document.addEventListener('click', later, true);
    document.addEventListener('keyup', later, true);
    new MutationObserver(syncSearch).observe(document.body, {
      subtree: true, attributes: true, attributeFilter: ['open', 'results', 'aria-expanded']
    });
    syncSearch();
  }

  function run() {
    if (C.cards) decorate(C.cardSelector || '.card__media', 'card');
    if (C.product) decorate(C.productSelector || '.product__media', 'product');
    if (C.header) decorate(C.headerSelector, 'header');
  }

  // Re-run when cards are added later (filters, sliders, infinite scroll, quick view, apps)
  function observe() {
    var queued = false;
    var mo = new MutationObserver(function (mutations) {
      if (queued) return;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          queued = true;
          window.requestAnimationFrame(function () {
            queued = false;
            run();
          });
          return;
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- Offer countdown ---------- */
  function countdown() {
    var box = document.querySelector('[data-dw-end]');
    if (!box) return;
    var end = Date.parse(box.getAttribute('data-dw-end'));
    if (isNaN(end)) {
      console.warn('[Diwali] Countdown date is not valid. Use 2026-11-08T23:59:59+05:30 format.');
      return;
    }
    var dEl = box.querySelector('[data-d]');
    var hEl = box.querySelector('[data-h]');
    var mEl = box.querySelector('[data-m]');
    var sEl = box.querySelector('[data-s]');
    var timer;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var ms = end - Date.now();
      if (ms <= 0) {
        box.hidden = true;
        clearInterval(timer);
        return;
      }
      var s = Math.floor(ms / 1000);
      dEl.textContent = pad(Math.floor(s / 86400));
      hEl.textContent = pad(Math.floor((s % 86400) / 3600));
      mEl.textContent = pad(Math.floor((s % 3600) / 60));
      sEl.textContent = pad(s % 60);
      box.hidden = false;
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  /* ---------- Golden sparkles ---------- */
  function sparkles() {
    if (!C.sparkles || reduceMotion) return;
    if (C.sparklesHomeOnly && C.template !== 'index') return;
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    if (mobile && !C.sparklesMobile) return;
    if (document.querySelector('.dw-sparkles')) return;

    var cv = document.createElement('canvas');
    cv.className = 'dw-sparkles';
    cv.setAttribute('aria-hidden', 'true');
    document.body.appendChild(cv);

    var ctx = cv.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0;

    function size() {
      W = window.innerWidth;
      H = window.innerHeight;
      cv.width = W * dpr;
      cv.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    size();
    window.addEventListener('resize', size);

    var colors = ['255,204,51', '255,153,51', '255,232,160'];
    var count = mobile ? 12 : 28;
    var P = [];

    function spawn(p, anywhere) {
      p.x = Math.random() * W;
      p.y = anywhere ? Math.random() * H : -10;
      p.r = 1 + Math.random() * 2.2;
      p.vy = 0.25 + Math.random() * 0.6;
      p.vx = (Math.random() - 0.5) * 0.3;
      p.ph = Math.random() * Math.PI * 2;
      p.c = colors[(Math.random() * colors.length) | 0];
      return p;
    }
    for (var i = 0; i < count; i++) P.push(spawn({}, true));

    // requestAnimationFrame pauses automatically in background tabs
    function frame() {
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < P.length; i++) {
        var p = P[i];
        p.ph += 0.03;
        p.y += p.vy;
        p.x += p.vx + Math.sin(p.ph) * 0.2;
        if (p.y > H + 10) spawn(p, false);
        var a = 0.45 + 0.55 * Math.abs(Math.sin(p.ph * 1.5));
        ctx.shadowColor = 'rgba(' + p.c + ',0.9)';
        ctx.shadowBlur = 8;
        ctx.fillStyle = 'rgba(' + p.c + ',' + a + ')';
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fill();
      }
      window.requestAnimationFrame(frame);
    }
    window.requestAnimationFrame(frame);
  }

  /* ---------- Start ---------- */
  function init() {
    run();
    observe();
    watchSearch();
    countdown();
    sparkles();
    // Theme Editor: re-apply when a section is edited
    document.addEventListener('shopify:section:load', run);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
